import { useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

const useDrag = () => {
  const [dragging, setDragging] = useState(false);

  const debouncedHandleDragOver = useDebouncedCallback(() => {
    setDragging(true);
  }, 50);

  const debouncedHandleDragLeave = useDebouncedCallback(() => {
    setDragging(false);
  }, 50);

  const handleDragOver = (e: DragEvent) => {
    e.preventDefault();
    debouncedHandleDragLeave.cancel();
    debouncedHandleDragOver();
  };

  const handleDragLeave = (e: DragEvent) => {
    e.preventDefault();
    debouncedHandleDragLeave();
  };

  const handleDrop = () => {
    debouncedHandleDragOver.cancel();

    setDragging(false);
    setTimeout(() => {
      setDragging(false);
    }, 250);
  };

  useEffect(() => {
    document.body.addEventListener('dragover', handleDragOver);
    document.body.addEventListener('dragleave', handleDragLeave);
    document.body.addEventListener('drop', handleDrop);

    return () => {
      document.body.removeEventListener('dragover', handleDragOver);
      document.body.removeEventListener('dragleave', handleDragLeave);
      document.body.removeEventListener('drop', handleDrop);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { dragging, onDrop: handleDrop };
};

export default useDrag;
